<script setup>
  defineOptions({
    name: "ComponentFrontDeskIcon",
  });
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="95"
    height="95"
    fill="none"
    viewBox="0 0 95 95"
    :data-test="getTestId('icon-svg-front-desk')"
  >
    <rect width="85.7" height="8.7" x="6.15" y="58.15" stroke="#1C1B1F" stroke-width="2.3" rx="1.85" />
    <rect width="77.7" height="26.7" x="10.15" y="67.15" stroke="#1C1B1F" stroke-width="2.3" rx="1.85" />
    <path fill="#1C1B1F" d="M51.625 86h-5.25v-4.375H42v-5.25h4.375V72h5.25v4.375H56v5.25h-4.375z" />
    <mask id="a" width="48" height="48" x="0" y="17" maskUnits="userSpaceOnUse" style="mask-type: alpha">
      <path fill="#D9D9D9" d="M0 17h48v48H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#1C1B1F"
        d="M17.858 58v-1.596l4.026-4.058h-14q-1.175 0-2.03-.854T5 49.462V26.884q0-1.175.854-2.03T7.884 24h32.231q1.178 0 2.031.854.855.854.854 2.03v22.578q0 1.175-.854 2.03-.855.854-2.03.854h-14l4.026 4.058V58zM7.27 46.45h33.46V26.884a.6.6 0 0 0-.191-.422.6.6 0 0 0-.424-.192H7.886a.6.6 0 0 0-.423.192.6.6 0 0 0-.192.422z"
      />
    </g>
    <path
      stroke="#1C1B1F"
      stroke-width="2.3"
      d="M50 58c.29-6.426 2.338-10.722 4.143-13.1.92-1.211 2.707-1.12 4.021-.356.336.195.678.384 1.003.558.83.444 1.444 1.218 1.633 2.14L63 58"
    />
    <path
      stroke="#1C1B1F"
      stroke-width="2.3"
      d="M56 43.5c-1 0-3 .6-3 3 0 3 3 1.5 3 4.5s-3.5 3 1.5 7M81.5 58c-.29-6.426-2.338-10.722-4.143-13.1-.92-1.211-2.707-1.12-4.021-.356-.336.195-.678.384-1.003.558-.83.444-1.444 1.218-1.633 2.14L68.5 58"
    />
    <path stroke="#1C1B1F" stroke-width="2.3" d="M75.5 43.5c1 0 3 .6 3 3 0 3-3 1.5-3 4.5s3.5 3-1.5 7" />
    <mask id="b" width="48" height="48" x="42" y="0" maskUnits="userSpaceOnUse" style="mask-type: alpha">
      <path fill="#D9D9D9" d="M42 0h48v48H42z" />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#1C1B1F"
        d="M59.765 32.754a2.52 2.52 0 0 1-1.865-.777 2.59 2.59 0 0 1-.766-1.887q0-1.11.777-1.865.777-.756 1.887-.756t1.865.77.756 1.884q0 1.1-.77 1.865-.769.765-1.884.766m12.477 0a2.52 2.52 0 0 1-1.865-.777 2.59 2.59 0 0 1-.766-1.887q0-1.11.777-1.865.777-.756 1.886-.756 1.11 0 1.866.77.756.769.756 1.884 0 1.1-.77 1.865-.769.765-1.884.766M65.998 44.73q7.005 0 11.869-4.869 4.863-4.87 4.863-11.885 0-1.257-.19-2.469a18 18 0 0 0-.5-2.261q-1.029.25-2.153.36t-2.376.11q-4.763 0-9.018-1.991a20.5 20.5 0 0 1-7.247-5.633 20.5 20.5 0 0 1-4.789 6.989 21.8 21.8 0 0 1-7.188 4.59V28q0 7.006 4.862 11.868t11.867 4.862m-5.021-32.734q3.957 5.42 8.077 7.435t8.453 2.015q1.201 0 2.006-.07a8.6 8.6 0 0 0 1.714-.338q-2.115-4.376-6.116-7.073Q71.112 11.27 66 11.27q-1.49 0-2.755.2-1.265.201-2.268.527M49.546 25.023q2.688-1.015 6.09-4.373 3.402-3.357 4.395-8.339-4.6 1.854-7.104 5.168t-3.381 7.544m-1.312-3.588a18.2 18.2 0 0 1 4.02-6.576 18.4 18.4 0 0 1 6.373-4.375 7.8 7.8 0 0 0-2.619-2.228q-1.572-.833-3.497-.833-3.219 0-5.442 2.224t-2.223 5.448q0 2.01.92 3.664a7.55 7.55 0 0 0 2.468 2.676M66.004 47q-3.943 0-7.411-1.497-3.468-1.495-6.034-4.06t-4.063-6.033Q47 31.942 47 28q0-1.12.133-2.22a14 14 0 0 1 .417-2.11q-2.245-1.282-3.61-3.549-1.363-2.265-1.363-5.017 0-4.15 2.9-7.05t7.05-2.9q2.592 0 4.77 1.227a9.9 9.9 0 0 1 3.526 3.342q1.223-.362 2.533-.542A19 19 0 0 1 66 9q3.942 0 7.41 1.496t6.032 4.06 4.061 6.032T85 27.996t-1.496 7.41q-1.495 3.47-4.06 6.035t-6.032 4.062Q69.946 47 66.003 47"
      />
    </g>
    <path fill="#34A223" d="M31 37a7 7 0 1 1-14 0 7 7 0 0 1 14 0" />
    <path
      fill="#fff"
      d="M26.544 36.079q-.22.002-.412.084l-1.33-2.2c.222-.209.364-.506.364-.84 0-.626-.491-1.135-1.095-1.135s-1.096.509-1.096 1.135c0 .28.102.533.265.73l-2.576 3.217a1.05 1.05 0 0 0-.54-.154c-.605 0-1.096.51-1.096 1.135 0 .626.491 1.136 1.095 1.136.38 0 .714-.201.91-.506l2.833 1.294q-.032.13-.034.27c0 .626.491 1.135 1.095 1.135s1.096-.51 1.096-1.135c0-.356-.163-.67-.41-.879l.577-1.083c.112.04.23.066.354.066.604 0 1.096-.51 1.096-1.135 0-.626-.492-1.136-1.096-1.136m-.73.295c-.21.196-.345.473-.36.784l-.797.104-.37-3.027q.102-.021.195-.062zm-4.65 1.344a1.1 1.1 0 0 0-.21-.397l2.576-3.216q.173.103.377.136l.375 3.07zm.02.604q.024-.104.03-.215l3.115-.407.183 1.495a1.1 1.1 0 0 0-.495.42zm4.097.854a1 1 0 0 0-.354-.066c-.015 0-.028.004-.043.004l-.179-1.462.798-.105c.065.218.19.406.356.546z"
    />
    <path
      fill="#fff"
      d="M26.544 36.427c-.419 0-.76.353-.76.787s.341.787.76.787.76-.353.76-.787-.341-.787-.76-.787M24.927 39.458c-.419 0-.76.353-.76.787s.341.787.76.787.76-.353.76-.787-.341-.787-.76-.787M20.123 37.265c-.418 0-.76.353-.76.787 0 .433.342.786.76.786.419 0 .76-.353.76-.786s-.341-.787-.76-.787M24.07 32.336c-.418 0-.759.353-.759.787s.341.787.76.787c.418 0 .759-.353.759-.787s-.34-.787-.76-.787"
    />
  </svg>
</template>
